import { render, staticRenderFns } from "./ForDesigners.vue?vue&type=template&id=1fae2d58&"
import script from "./ForDesigners.vue?vue&type=script&lang=js&"
export * from "./ForDesigners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports